import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';  // Icono de Home
import '../Styles/Header.css';

const Header = ({ username, userImage }) => {
  const navigate = useNavigate(); 

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/dashboardlogout');
  };

  const handleDashboard = () => {
    navigate('/dashboardlogout');
  };

  const handleHome = () => {
    navigate('/dashboard');
  };

  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user'));

  return (
    <header className="dashboard-header d-flex justify-content-between align-items-center p-3">
      {token ? (
        <>
          <div className="d-flex">
            <button className="btn btn-primary mr-4" onClick={handleHome}>
              <FaHome className="mr-2" /> Home
            </button>
            <button className="btn btn-primary" onClick={handleLogout}>Cerrar sesión</button>
          </div>

          <div className="d-flex align-items-center">
            <h3 className="username mr-2">{user.name}</h3>
            <img src={userImage} alt={user.name} className="user-image rounded-circle" width="40" height="40" />
          </div>
        </>
      ) : (
        <>
          <button className="btn btn-secondary mr-3" onClick={handleDashboard}>Ir al Dashboard</button>
          <button className="btn btn-secondary" onClick={() => navigate('/login')}>Iniciar sesión</button>
        </>
      )}
    </header>
  );
};

export { Header };
